import { React, useState, useEffect } from 'react'
import './BiodataDiri.css'
import { useHistory } from "react-router-dom";



export default function BiodataDiri() {

    const navigate = useHistory()

    const initialData = JSON.parse(localStorage.getItem("biodata"))

    useEffect(() => {
        if (initialData != null){
            setBiodata(initialData)
        }
    }, [])
    
    const [condition, setCondition] = useState({
        isCompleted: true
    })

    const [daerah, setDaerah] = useState([
        {
            "id":0,
            "provinsi": "Aceh",
            "kota": [
                "Kota Banda Aceh",
                "Kota Sabang",
                "Kota Lhokseumawe",
                "Kota Langsa",
                "Kota Subulussalam",
                "Kab. Aceh Selatan",
                "Kab. Aceh Tenggara",
                "Kab. Aceh Timur",
                "Kab. Aceh Tengah",
                "Kab. Aceh Barat",
                "Kab. Aceh Besar",
                "Kab. Pidie",
                "Kab. Aceh Utara",
                "Kab. Simeulue",
                "Kab. Aceh Singkil",
                "Kab. Bireun",
                "Kab. Aceh Barat Daya",
                "Kab. Gayo Lues",
                "Kab. Aceh Jaya",
                "Kab. Nagan Raya",
                "Kab. Aceh Tamiang",
                "Kab. Bener Meriah",
                "Kab. Pidie Jaya"
            ]
        },

        {
            "id":1,
            "provinsi": "Sumatera Utara",
            "kota": [
                "Kota Medan",
                "Kota Pematang Siantar",
                "Kota Sibolga",
                "Kota Tanjung Balai",
                "Kota Binjai",
                "Kota Tebing Tinggi",
                "Kota Padang Sidempuan",
                "Kota Gunung Sitoli",
                "Kab. Serdang Bedagai",
                "Kab. Samosir ",
                "Kab. Humbang Hasundutan",
                "Kab. Pakpak Bharat",
                "Kab. Nias Selatan",
                "Kab. Mandailing Natal",
                "Kab. Toba Samosir",
                "Kab. Dairi",
                "Kab. Labuhan Batu",
                "Kab. Asahan",
                "Kab. Simalungun",
                "Kab. Deli Serdang",
                "Kab. Karo",
                "Kab. Langkat",
                "Kab. Nias",
                "Kab. Tapanuli Selatan",
                "Kab. Tapanuli Utara",
                "Kab. Tapanuli Tengah",
                "Kab. Batu Bara",
                "Kab. Padang Lawas Utara",
                "Kab. Padang Lawas",
                "Kab. Labuhanbatu Selatan",
                "Kab. Labuhanbatu Utara",
                "Kab. Nias Utara",
                "Kab. Nias Barat"
            ]
        },

        {
            "id":2,
            "provinsi": "Sumatera Barat",
            "kota": [
                "Kota Padang",
                "Kota Solok",
                "Kota Sawhlunto",
                "Kota Padang Panjang",
                "Kota Bukittinggi",
                "Kota Payakumbuh",
                "Kota Pariaman",
                "Kab. Pasaman Barat",
                "Kab. Solok Selatan",
                "Kab. Dharmasraya",
                "Kab. Kepulauan Mentawai",
                "Kab. Pasaman",
                "Kab. Lima Puluh Kota",
                "Kab. Agam",
                "Kab. Padang Pariaman",
                "Kab. Tanah Datar",
                "Kab. Sijunjung",
                "Kab. Solok",
                "Kab. Pesisir Selatan"
            ]
        },

        {
            "id":3,
            "provinsi": "Riau",
            "kota": [
                "Kota Pekan Baru",
                "Kota Dumai",
                "Kab. Kepulauan Meranti",
                "Kab. Kuantan Singingi",
                "Kab. Siak",
                "Kab. Rokan Hilir",
                "Kab. Rokan Hulu",
                "Kab. Pelalawan",
                "Kab. Indragiri Hilir",
                "Kab. Bengkalis",
                "Kab. Indragiri Hulu",
                "Kab. Kampar"
            ]
        },

        {
            "id":4,
            "provinsi": "Jambi",
            "kota": [
                "Kota Jambi",
                "Kota Sungai Penuh",
                "Kab. Tebo",
                "Kab. Bungo",
                "Kab. Tanjung Jabung Timur",
                "Kab. Tanjung Jabung Barat",
                "Kab. Muaro Jambi",
                "Kab. Batanghari",
                "Kab. Sarolangun",
                "Kab. Merangin",
                "Kab. Kerinci"
            ]
        },

        {
            "id":5,
            "provinsi": "Sumatera Selatan",
            "kota": [
                "Kota Palembang",
                "Kota Pagar Alam",
                "Kota Lubuk Linggau",
                "Kota Prabumulih",
                "Kab. Musi Rawas Utara",
                "Kab. Penukal Abab Lematang Ilir",
                "Kab. Empat Lawang",
                "Kab. Ogan Ilir ",
                "Kab. Ogan Komering Ulu Selatan ",
                "Kab. Ogan Komering Ulu Timur ",
                "Kab. Banyuasin",
                "Kab. Musi Banyuasin",
                "Kab. Musi Rawas",
                "Kab. Lahat",
                "Kab. Muara Enim",
                "Kab. Ogan Komering Ilir",
                "Kab. Ogan Komering Ulu"
            ]
        },

        {
            "id":6,
            "provinsi": "Bengkulu",
            "kota": [
                "Kota Bengkulu",
                "Kab. Bengkulu Tengah",
                "Kab. Kepahiang ",
                "Kab. Lebong",
                "Kab. Muko Muko",
                "Kab. Seluma",
                "Kab. Kaur",
                "Kab. Bengkulu Utara",
                "Kab. Rejang Lebong",
                "Kab. Bengkulu Selatan"
            ]
        },

        {
            "id":7,
            "provinsi": "Lampung",
            "kota": [
                "Kota Bandar Lampung",
                "Kota Metro",
                "Kab. Pesisir Barat",
                "Kab. Tulangbawang Barat",
                "Kab. Mesuji",
                "Kab. Pringsewu",
                "Kab. Pesawaran",
                "Kab. Way Kanan",
                "Kab. Lampung Timur",
                "Kab. Tanggamus",
                "Kab. Tulang Bawang",
                "Kab. Lampung Barat",
                "Kab. Lampung Utara",
                "Kab. Lampung Tengah",
                "Kab. Lampung Selatan"
            ]
        },

        {
            "id":8,
            "provinsi": "Kepulauan Bangka Belitung",
            "kota": [
                "Kota Pangkal Pinang",
                "Kab. Belitung Timur",
                "Kab. Bangka Barat",
                "Kab. Bangka Tengah",
                "Kab. Bangka Selatan",
                "Kab. Belitung",
                "Kab. Bangka"
            ]
        },

        {
            "id":9,
            "provinsi": "Kepulauan Riau",
            "kota": [
                "Kota Batam",
                "Kota Tanjung Pinang",
                "Kab. Kepulauan Anambas",
                "Kab. Lingga ",
                "Kab. Natuna",
                "Kab. Karimun",
                "Kab. Bintan"
            ]
        },

        {
            "id":10,
            "provinsi": "DKI Jakarta",
            "kota": [
                "Kota Jakarta Timur",
                "Kota Jakarta Selatan",
                "Kota Jakarta Barat",
                "Kota Jakarta Utara",
                "Kota Jakarta Pusat",
                "Kab. Kepulauan Seribu"
            ]
        },

        {
            "id":11,
            "provinsi": "Jawa Barat",
            "kota": [
                "Kota Bandung",
                "Kota Banjar",
                "Kota Tasikmalaya",
                "Kota Cimahi",
                "Kota Depok",
                "Kota Bekasi",
                "Kota Cirebon",
                "Kota Sukabumi",
                "Kota Bogor",
                "Kab. Pangandaran",
                "Kab. Bandung Barat",
                "Kab. Bekasi",
                "Kab. Karawang",
                "Kab. Purwakarta",
                "Kab. Subang",
                "Kab. Indramayu",
                "Kab. Sumedang",
                "Kab. Majalengka",
                "Kab. Cirebon",
                "Kab. Kuningan",
                "Kab. Ciamis",
                "Kab. Tasikmalaya",
                "Kab. Garut",
                "Kab. Bandung",
                "Kab. Cianjur",
                "Kab. Sukabumi",
                "Kab. Bogor"
            ]
        },

        {
            "id":12,
            "provinsi": "Jawa Tengah",
            "kota": [
                "Kota Semarang",
                "Kota Tegal",
                "Kota Pekalongan",
                "Kota Salatiga",
                "Kota Surakarta",
                "Kota Magelang",
                "Kab. Brebes",
                "Kab. Tegal",
                "Kab. Pemalang",
                "Kab. Pekalongan",
                "Kab. Batang",
                "Kab. Kendal",
                "Kab. Temanggung",
                "Kab. Semarang",
                "Kab. Demak",
                "Kab. Jepara",
                "Kab. Kudus",
                "Kab. Pati",
                "Kab. Rembang",
                "Kab. Blora",
                "Kab. Grobogan",
                "Kab. Sragen",
                "Kab. Karanganyar",
                "Kab. Wonogiri",
                "Kab. Sukoharjo",
                "Kab. Klaten",
                "Kab. Boyolali",
                "Kab. Magelang",
                "Kab. Wonosobo",
                "Kab. Purworejo",
                "Kab. Kebumen",
                "Kab. Banjarnegara",
                "Kab. Purbalingga",
                "Kab. Banyumas",
                "Kab. Cilacap"
            ]
        },

        {
            "id":13,
            "provinsi": "DI Yogyakarta",
            "kota": [
                "Kota Yogyakarta",
                "Kab. Sleman",
                "Kab. Gunung Kidul",
                "Kab. Bantul",
                "Kab. Kulon Progo"
            ]
        },

        {
            "id":14,
            "provinsi": "Jawa Timur",
            "kota": [
                "Kota Surabaya",
                "Kota Batu",
                "Kota Madiun",
                "Kota Mojokerto",
                "Kota Pasuruan",
                "Kota Probolinggo",
                "Kota Malang",
                "Kota Blitar",
                "Kota Kediri",
                "Kab. Sumenep",
                "Kab. Pamekasan",
                "Kab. Sampang",
                "Kab. Bangkalan",
                "Kab. Gresik",
                "Kab. Lamongan",
                "Kab. Tuban",
                "Kab. Bojonegoro",
                "Kab. Ngawi",
                "Kab. Magetan",
                "Kab. Madiun",
                "Kab. Nganjuk",
                "Kab. Jombang",
                "Kab. Mojokerto",
                "Kab. Sidoarjo",
                "Kab. Pasuruan",
                "Kab. Probolinggo",
                "Kab. Situbondo",
                "Kab. Bondowoso",
                "Kab. Banyuwangi",
                "Kab. Jember",
                "Kab. Lumajang",
                "Kab. Malang",
                "Kab. Kediri",
                "Kab. Blitar",
                "Kab. Tulungagung",
                "Kab. Trenggalek",
                "Kab. Ponorogo",
                "Kab. Pacitan"
            ]
        },

        {
            "id":15,
            "provinsi": "Banten",
            "kota": [
                "Kota Serang",
                "Kota Cilegon",
                "Kota Tangerang",
                "Kota Tangerang Selatan",
                "Kab. Serang",
                "Kab. Tangerang",
                "Kab. Lebak",
                "Kab. Pandeglang"
            ]
        },

        {
            "id":16,
            "provinsi": "Bali",
            "kota": [
                "Kota Denpasar",
                "Kab. Buleleng",
                "Kab. Karangasem",
                "Kab. Bangli",
                "Kab. Klungkung",
                "Kab. Gianyar",
                "Kab. Badung",
                "Kab. Tabanan",
                "Kab. Jembrana"
            ]
        },

        {
            "id":17,
            "provinsi": "Nusa Tenggara Barat",
            "kota": [
                "Kota Mataram",
                "Kota Bima",
                "Kab. Lombok Utara",
                "Kab. Sumbawa Barat",
                "Kab. Bima",
                "Kab. Dompu",
                "Kab. Sumbawa ",
                "Kab. Lombok Timur",
                "Kab. Lombok Tengah",
                "Kab. Lombok Barat"
            ]
        },

        {
            "id":18,
            "provinsi": "Nusa Tenggara Timur",
            "kota": [
                "Kota Kupang",
                "Kab. Malaka",
                "Kab. Sabu Raijua",
                "Kab. Manggarai Timur",
                "Kab. Sumba Barat Daya",
                "Kab. Sumba Tengah",
                "Kab. Nagekeo",
                "Kab. Manggarai Barat",
                "Kab. Rote Ndao",
                "Kab. Lembata",
                "Kab. Sumba Barat",
                "Kab. Sumba Timur",
                "Kab. Manggarai",
                "Kab. Ngada",
                "Kab. Ende",
                "Kab. Sikka",
                "Kab. Flores Timur",
                "Kab. Alor",
                "Kab. Belu",
                "Kab. Timor Tengah Utara",
                "Kab. Timor Tengah Selatan",
                "Kab. Kupang"
            ]
        },
        {
            "id":19,
            "provinsi": "Kalimantan Barat",
            "kota": [
                "Kota Pontianak",
                "Kota Singkawang",
                "Kab. Kubu Raya",
                "Kab. Kayong Utara",
                "Kab. Sekadau",
                "Kab. Melawi",
                "Kab. Landak",
                "Kab. Bengkayang",
                "Kab. Kapuas Hulu",
                "Kab. Sintang ",
                "Kab. Ketapang",
                "Kab. Sanggau ",
                "Kab. Mempawah",
                "Kab. Sambas"
            ]
        },

        {
            "id":20,
            "provinsi": "Kalimantan Tengah",
            "kota": [
                "Kota Palangkaraya",
                "Kab. Barito Timur",
                "Kab. Murung Raya",
                "Kab. Pulang Pisau",
                "Kab. Gunung Mas",
                "Kab. Lamandau",
                "Kab. Sukamara",
                "Kab. Seruyan",
                "Kab. Katingan",
                "Kab. Barito Utara",
                "Kab. Barito Selatan",
                "Kab. Kapuas",
                "Kab. Kotawaringin Timur",
                "Kab. Kotawaringin Barat"
            ]
        },

        {
            "id":21,
            "provinsi": "Kalimantan Selatan",
            "kota": [
                "Kota Banjarmasin",
                "Kota Banjarbaru",
                "Kab. Balangan",
                "Kab. Tanah Bambu",
                "Kab. Tabalong",
                "Kab. Hulu Sungai Utara",
                "Kab. Hulu Sungai Tengah",
                "Kab. Hulu Sungai Selatan",
                "Kab. Tapin",
                "Kab. Barito Kuala",
                "Kab. Banjar",
                "Kab. Kotabaru",
                "Kab. Tanah Laut"
            ]
        },

        {   "id":22,
            "provinsi": "Kalimantan Timur",
            "kota": [
                "Kota Samarinda",
                "Kota Bontang",
                "Kota Balikpapan",
                "Kab. Mahakam Ulu",
                "Kab. Penajam Paser Utara",
                "Kab. Kutai Timur",
                "Kab. Kutai Barat",
                "Kab. Berau",
                "Kab. Kutai Kertanegara",
                "Kab. Paser"
            ]
        },

        {
            "id":23,
            "provinsi": "Kalimantan Utara",
            "kota": [
                "Kota Tarakan",
                "Kab. Tana Tidung",
                "Kab. Nunukan",
                "Kab. Malinau",
                "Kab. Bulungan"
            ]
        },

        {
            "id":24,
            "provinsi": "Sulawesi Utara",
            "kota": [
                "Kota Manado",
                "Kota Tomohon",
                "Kota Bitung",
                "Kota Kotamobagu",
                "Kab. Bolaang Mangondow Selatan",
                "Kab. Bolaang Mangondow Timur",
                "Kab. Kepulauan Siau Tagulandang Biaro",
                "Kab. Bolaang Mangondow Utara",
                "Kab. Minahasa Tenggara",
                "Kab. Minahasa Utara",
                "Kab. Minahasa Selatan",
                "Kab. Kepulauan Talaud",
                "Kab. Kepulauan Sangihe",
                "Kab. Minahasa",
                "Kab. Bolaang Mangondow"
            ]
        },

        {
            "id":25,
            "provinsi": "Sulawesi Tengah",
            "kota": [
                "Kota Palu",
                "Kab. Morowali Utara",
                "Kab. Banggai Laut",
                "Kab. Sigi",
                "Kab. Tojo Una-Una",
                "Kab. Parigi Moutong",
                "Kab. Banggai Kepulauan",
                "Kab. Morowali",
                "Kab. Buol",
                "Kab. Toli-Toli",
                "Kab. Donggala",
                "Kab. Poso",
                "Kab. Banggai"
            ]
        },

        {
            "id":26,
            "provinsi": "Sulawesi Selatan",
            "kota": [
                "Kota Makasar",
                "Kota Palopo",
                "Kota Pare Pare",
                "Kab. Toraja Utara",
                "Kab. Luwu Timur",
                "Kab. Luwu Utara",
                "Kab. Tana Toraja",
                "Kab. Luwu",
                "Kab. Enrekang",
                "Kab. Pinrang",
                "Kab. Sidenreng Rappang",
                "Kab. Wajo",
                "Kab. Soppeng",
                "Kab. Barru",
                "Kab. Pangkajene Kepulauan",
                "Kab. Maros",
                "Kab. Bone",
                "Kab. Sinjai",
                "Kab. Gowa",
                "Kab. Takalar",
                "Kab. Jeneponto",
                "Kab. Bantaeng",
                "Kab. Bulukumba",
                "Kab. Kepulauan Selayar"
            ]
        },

        {
            "id":27,
            "provinsi": "Sulawesi Tenggara",
            "kota": [
                "Kota Kendari",
                "Kota Bau Bau",
                "Kab. Buton Selatan",
                "Kab. Buton Tengah",
                "Kab. Muna Barat",
                "Kab. Konawe Kepulauan",
                "Kab. Kolaka Timur",
                "Kab. Buton Utara",
                "Kab. Konawe Utara",
                "Kab. Kolaka Utara",
                "Kab. Wakatobi",
                "Kab. Bombana",
                "Kab. Konawe Selatan",
                "Kab. Buton",
                "Kab. Muna",
                "Kab. Konawe",
                "Kab. Kolaka"
            ]
        },

        {
            "id":28,
            "provinsi": "Gorontalo",
            "kota": [
                "Kota Gorontalo",
                "Kab. Pohuwato",
                "Kab. Bone Bolango",
                "Kab. Boalemo",
                "Kab. Gorontalo",
                "Kab. Gorontalo Utara"
            ]
        },

        {
            "id":29,
            "provinsi": "Sulawesi Barat",
            "kota": [
                "Kab. Majene",
                "Kab. Polowali Mandar",
                "Kab. Mamasa",
                "Kab. Mamuju",
                "Kab. Mamuju Utara",
                "Kab. Mamuju Tengah"
            ]
        },

        {
            "id":30,
            "provinsi": "Maluku",
            "kota": [
                "Kota Ambon",
                "Kota Tual",
                "Kab. Buru Selatan",
                "Kab. Maluku Barat Daya",
                "Kab. Kepulauan Aru",
                "Kab. Seram Bagian Barat ",
                "Kab. Seram Bagian Timur",
                "Kab. Buru",
                "Kab. Maluku Tenggara Barat",
                "Kab. Maluku Tenggara",
                "Kab. Maluku Tengah"
            ]
        },

        {
            "id":31,
            "provinsi": "Maluku Utara",
            "kota": [
                "Kota Ternate",
                "Kota Tidore Kepulauan",
                "Kab. Pulau Taliabu",
                "Kab. Pulau Morotai",
                "Kab. Halmahera Timur",
                "Kab. Kepulauan Sula",
                "Kab. Halmahera Selatan",
                "Kab. Halmahera Utara",
                "Kab. Halmahera Tengah",
                "Kab. Halmahera Barat"
            ]
        },

        {
            "id":32,
            "provinsi": "Papua",
            "kota": [
                "Kota Jayapura",
                "Kab. Deiyai",
                "Kab. Intan Jaya",
                "Kab. Dogiyai",
                "Kab. Puncak",
                "Kab. Nduga",
                "Kab. Lanny Jaya",
                "Kab. Yalimo",
                "Kab. Mamberamo Tengah",
                "Kab. Mamberamo Raya",
                "Kab. Supiori",
                "Kab. Asmat",
                "Kab. Mappi",
                "Kab. Boven Digoel",
                "Kab. Waropen",
                "Kab. Tolikara",
                "Kab. Yahukimo",
                "Kab. Pegunungan Bintang",
                "Kab. Keerom",
                "Kab. Sarmi",
                "Kab. Mimika",
                "Kab. Paniai",
                "Kab. Puncak Jaya",
                "Kab. Biak Numfor",
                "Kab. Kepulauan Yapen",
                "Kab. Nabire",
                "Kab. Jayapura",
                "Kab. Jayawijaya",
                "Kab. Merauke"
            ]
        },

        {
            "id":33,
            "provinsi": "Papua Barat",
            "kota": [
                "Kota Sorong",
                "Kab. Pegunungan Arfak",
                "Kab. Manokwari Selatan",
                "Kab. Maybrat",
                "Kab. Tambrauw",
                "Kab. Kaimana",
                "Kab. Teluk Wondama",
                "Kab. Teluk Bintuni",
                "Kab. Raja Ampat",
                "Kab. Sorong Selatan",
                "Kab. Fak Fak",
                "Kab. Manokwari",
                "Kab. Sorong"
            ]
        }
    ])

    const [kota, setKota] = useState([
        "Kota Banda Aceh",
        "Kota Sabang",
        "Kota Lhokseumawe",
        "Kota Langsa",
        "Kota Subulussalam",
        "Kab. Aceh Selatan",
        "Kab. Aceh Tenggara",
        "Kab. Aceh Timur",
        "Kab. Aceh Tengah",
        "Kab. Aceh Barat",
        "Kab. Aceh Besar",
        "Kab. Pidie",
        "Kab. Aceh Utara",
        "Kab. Simeulue",
        "Kab. Aceh Singkil",
        "Kab. Bireun",
        "Kab. Aceh Barat Daya",
        "Kab. Gayo Lues",
        "Kab. Aceh Jaya",
        "Kab. Nagan Raya",
        "Kab. Aceh Tamiang",
        "Kab. Bener Meriah",
        "Kab. Pidie Jaya"
    ])
    const [kotaLahir, setKotalahir] = useState([
    ])

    const [data, setData] = useState({
        StatusKepegawaian: "PNS",
    })

    const [biodata, setBiodata] = useState({
        nik : "",
        statusKepegawaian : "Silahkan Pilih",
        jabatan:"Silahkan Pilih",
        tmtAwal :"",
        tmtAkhir : "",
        nip :"0",
        nrg :"0",
        nuks :"0",
        nuptk :"0",
        namaLengkap :"",
        gender :"Silahkan Pilih",
        statusPerkawinan :"Silahkan Pilih",
        tempatLahir :"Silahkan Pilih",
        tanggalLahir :"",
        nomorTelepon :"",
        email :"",
        kotaDomisili:"Kota Banda Aceh",
        kecamatanDomisili:"",
        rt:"",
        rw:"",
        kodePos:"",
        lintang:"",
        bujur:"",
        dapodik:""
    })
    const [status, setStatus] = useState({
        Tmt: "TMT CPNS",
        TmtLast: "TMT Pangkat Terakhir",
        pangkatDisplay: ""
    })

    const handleFormChange = e =>{
        setBiodata({
            ...biodata,
            [e.target.name]: e.target.value
        })
    }
    

    useEffect(() => {
        if (data.StatusKepegawaian == "GTT" || data.StatusKepegawaian == "PTT") {
            setStatus({
                ...status,
                Tmt: "TMT Pengangkatan",
                pangkatDisplay: "none"
            })
        } else if (data.StatusKepegawaian == "PNS") {
            setStatus({
                ...status,
                Tmt: "TMT CPNS",
                TmtLast: "TMT Pangkat Terakhir",
                pangkatDisplay: ""
            })
        } else if (data.StatusKepegawaian == "PPPK") {
            setStatus({
                ...status,
                Tmt: "TMT Mulai",
                TmtLast: "TMT Selesai"
            })
        }
    }, [data])

    const onChangeKepegawaian = (e) => {
        setData({
            ...data,
            StatusKepegawaian: e.target.value
        })

       
    }

    const onClick = e => {
        e.preventDefault()
        if (biodata.namaLengkap == "" ||
            biodata.dapodik == "" ||
            biodata.email == "" || 
            biodata.bujur == "" ||
            biodata.lintang == ""||
            biodata.gender == ""||
            biodata.gender == "Silahkan Pilih"||
            biodata.gender == undefined ||
            biodata.jabatan == ""||
            biodata.jabatan == "Silahkan Pilih" ||
            biodata.jabatan == undefined ||
            biodata.kecamatanDomisili == ""||
            biodata.nomorTelepon == ""||
            biodata.statusKepegawaian == undefined||
            biodata.statusKepegawaian == "Silahkan Pilih"||
            biodata.statusKepegawaian == ""||
            biodata.statusPerkawinan == ""||
            biodata.statusPerkawinan == "Silahkan Pilih"||
            biodata.tanggalLahir == ""||
            biodata.tempatLahir == ""||
            biodata.tempatLahir == "Silahkan Pilih"||
            biodata.tmtAwal == ""
        ){
            // navigate.push('/InputData/Guru/biodataDiri/jadwal')
            console.log ("FULLFILL FIRST")
            console.log (biodata)
            setCondition({
                ...condition,
                isCompleted : false
            })
            
        } else{
            console.log ("FULLFilled")
            navigate.push('/InputData/Guru/biodataDiri/jadwal')
            localStorage.setItem('biodata',JSON.stringify(biodata))
        }
        // localStorage.setItem('biodata',JSON.stringify(biodata))
        // navigate.push('./biodataDiri/jadwal')
    }
    // const onClickBack = e => {
    //     e.preventDefault()
    //     navigate.push('/InputData/Guru')
    // }
    const handleProvinsiChange = (e) =>{
        let id = parseInt(e.target.value)
        setKota(
            daerah[id].kota
        )
    }
    const handleProvinsiChange2 = (e) =>{
        let id = parseInt(e.target.value)
        setKotalahir(
            daerah[id].kota
        )
        console.log(kotaLahir)
    }

    return (
        <div className='Biodata-wrapper'>
            <div className='Biodata-Error' hidden={condition.isCompleted}>
                Mohon Cek Kembali Isian Form
            </div>
            <div className='Judul-Wrapper'>
                <h1 className='Judul-Bold'>BIODATA</h1><h1 className='Judul-Thin'>DIRI</h1>
            </div>
            <form onChange={handleFormChange}>
            <div className='biodataFormWrapper'>
                <p>NIK</p>
                <input name='nik' type="text" maxLength={16} value={biodata.nik} />
                <div className='doubleInput'>
                    <div>
                        <p>Status Kepegawaian</p>
                        <select name='statusKepegawaian' onChange={onChangeKepegawaian}>
                            <option value="">{biodata.statusKepegawaian}</option>
                            <option value="PNS">PNS</option>
                            <option value="PPPK">PPPK</option>
                            <option value="GTT">GTT(Guru Tidak Tetap)</option>
                            <option value="PTT">PTT(Pegawai Tidak Tetap)</option>
                        </select>
                    </div>
                    <div>
                        <p>{status.Tmt}</p>
                        <input type="date" name="tmtAwal" value={biodata.tmtAwal} />
                    </div>
                </div>
                
                    <div>
                        <p>Jabatan</p>
                        <input name='jabatan'value={biodata.jabatan}/>
                        {/* <select name='jabatan'>
                            <option value="">{biodata.jabatan}</option>
                            <option value="Kepala Sekolah">Kepala Sekolah</option>
                            <option value="Kepala Sekolah (PLT)">Kepala Sekolah (PLT)</option>
                            <option value="Guru">Guru</option>
                            <option value="Staff">Staff</option>

                        </select> */}
                    <div className='doubleInput'>
                    </div>
                    <div style={{ display: status.pangkatDisplay }}>
                        <p>{status.TmtLast}</p>
                        <input type="date" name="tmtAkhir" value={biodata.tmtAkhir}/>
                    </div>
                </div>
                <p>NIP</p>
                <input name='nip' type = "number"value={biodata.nip}/>
                <p>NRG</p>
                <input name='nrg'type = "number"value={biodata.nrg} />
                <p>NUKS</p>
                <input name='nuks'value={biodata.nuks}/>
                <p>NUPTK</p>
                <input name='nuptk' type = "number"value={biodata.nuptk}/>
            </div>
            <div className='biodataFormWrapper'>
                <p>Nama Lengkap</p>
                <input name='namaLengkap' value={biodata.namaLengkap}/>
                <div className='doubleInput'>
                    <div>
                        <p>Gender</p>
                        <select name="gender">
                            <option value="">{biodata.gender}</option>
                            <option value="Laki-laki">Laki-laki</option>
                            <option value="Perempuan">Perempuan</option>
                        </select>
                    </div>
                    <div>
                        <p>Status Perkawinan</p>
                        <select name='statusPerkawinan'>
                        <option value="">{biodata.statusPerkawinan}</option>
                            <option value="Kawin">Kawin</option>
                            <option value="Belum Kawin">Belum Kawin</option>
                            <option value="Cerai Hidup">Cerai Hidup</option>
                            <option value="Cerai Mati">Cerai Mati</option>
                        </select>
                    </div>
                </div>
                <div className='doubleInput'>
                    <div>
                        <p>Provinsi Tempat Lahir</p>
                        <select onChange={handleProvinsiChange2}>
                        <option value="">Silahkan Pilih</option>
                        {daerah.map(item =>
                            <option value={item.id}>{item.provinsi}</option>
                        )}
                    </select>
                    </div>
                    <div>
                        <p>Tanggal Lahir</p>
                        <input type="date" name='tanggalLahir' value={biodata.tanggalLahir}/>
                    </div>
                </div>
                <div className='doubleInput'>
                    <div>
                        <p>Kota Tempat Lahir</p>
                        <select name='tempatLahir'>
                        <option value="">{biodata.tempatLahir}</option>
                        {kotaLahir.map(item1 =>
                            <option value={item1}>{item1}</option>
                        )}
                        </select>
                    </div>
                </div>
                <p>Nomor Telepon</p>
                <input name='nomorTelepon' value={biodata.nomorTelepon}/>
                <p>Email</p>
                <input name='email' value={biodata.email}/>
                <p>Alamat Domisili</p>
                <div className='alamat-Wrapper'>
                    <p>Provinsi</p>
                    <select onChange={handleProvinsiChange}>
                        {daerah.map(item =>
                            <option value={item.id}>{item.provinsi}</option>
                        )}
                    </select>

                    <p>Kota</p>
                    <select name='kotaDomisili'>
                    {kota.map(item =>
                            <option value={item}>{item}</option>
                        )}
                    </select>
                    <p>Alamat Lengkap</p>
                    <input name='kecamatanDomisili' value={biodata.kecamatanDomisili}/>
                </div>
                <div className='tripleInput'>
                    <div>
                        <p>RT</p>
                        <input name='rt' value={biodata.rt}/>
                    </div>
                    <div>
                        <p>RW</p>
                        <input name='rw' value={biodata.rw}/>
                    </div>
                    <div>
                        <p>Kode Pos</p>
                        <input name='kodePos' value={biodata.kodePos}/>
                    </div>
                </div>
                <div className='doubleInput2'>
                    <div>
                        <p>Lintang</p>
                        <input name='lintang' value={biodata.lintang}/>
                    </div>
                    <div>
                        <p>Bujur</p>
                        <input name='bujur' value={biodata.bujur}/>
                    </div>
                </div>
                <div className='dapodik-Radio'>
                    <div className='dapodikText'>Terdaftar di DAPODIK</div>
                    <div>Ya</div>
                    <input type="radio" name='dapodik' value="ya"/>
                    <div>Tidak</div>
                    <input type="radio" name='dapodik'value="tidak"/>
                </div>
            </div>
            </form>
            <div className='jadwalButton-Wrapper'>
                <button onClick={onClick} style={{ cursor: "pointer" }}>Simpan dan Lanjut</button>
                {/* <h1 onClick={onClickBack} style={{ cursor: "pointer" }}>←Kembali</h1> */}
            </div>
        </div>
    )
}
